<div class="content-table" style="max-height: initial">
  <p class="empty" *ngIf="isEmpty">No se encontraron datos</p>

  <table
    *ngIf="!isEmpty"
    style="text-align: center"
    mat-table
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="createdAt">
      <th class="center" mat-header-cell *matHeaderCellDef>Creado</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.createdAt | date : "short" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="updated">
      <th class="center" mat-header-cell *matHeaderCellDef>Modificado</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.updatedAt | date : "short" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="gai">
      <th class="center" mat-header-cell *matHeaderCellDef>Código</th>
      <td
        class="paddingLR"
        mat-cell
        style="cursor: pointer"
        (click)="goRoute(element)"
        *matCellDef="let element"
      >
        {{ element.gai }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th class="center" mat-header-cell *matHeaderCellDef>Descripción</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.descripcion }}
      </td>
    </ng-container>

    <ng-container matColumnDef="assigned">
      <th class="center" mat-header-cell *matHeaderCellDef>Asignado a</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.assigned?.fullname || "Sin asignar *" }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
